module.exports = __webpack_public_path__ + "static/media/lock.b770277c.png";